import { render, staticRenderFns } from "./editDeliver.vue?vue&type=template&id=f77ac8f8&scoped=true&"
import script from "./editDeliver.vue?vue&type=script&lang=js&"
export * from "./editDeliver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77ac8f8",
  null
  
)

export default component.exports